import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterOutlet, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';

import { SideNavigationComponent } from './side-navigation/side-navigation.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HttpClientModule, SideNavigationComponent, RouterLink, MatIconModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  translateService = inject(TranslateService);
  title = 'AirProducts Driver Management System';

  constructor() {
    this.translateService.use(this.translateService.getBrowserCultureLang());

  }

  ngOnInit(): void {
  }
}
